import { IConfig } from '@cian/config/shared';

import { IJsonQuery } from 'shared/json_query';

export function isRedirectNeeded(config: IConfig, jsonQuery: IJsonQuery, fullUrl?: string): boolean {
  if (config.get('redirectToOldFilters') !== 'enabled') {
    return false;
  }

  if (!fullUrl) {
    return false;
  }

  let queryHasMapObjects = false;

  if (jsonQuery.geo && jsonQuery.geo.value) {
    queryHasMapObjects = jsonQuery.geo.value.some(geoObject => {
      return geoObject.type === 'polygon' || geoObject.type === 'distance';
    });
  }

  if (!queryHasMapObjects) {
    const parser = document.createElement('a');
    parser.href = fullUrl;

    return parser.hostname !== window.location.hostname;
  }

  return false;
}
